<script>
  /**
   * ID of the currently selected tab. Bind this value.
   * @type {string | null}
   */
  export let currentTabId = null

  /**
   * List of tab objects (id and label)
   * @type {{
   *   id: string,
   *   label: string,
   * }[]}
   */
  export let tabs
</script>

<div style="display: flex; border-bottom: 1px solid lightgrey; gap: 1rem; font-size: 1.2rem; color: lightgrey; width: 100%">
  {#each tabs as tab}
    <button
      class="tab"
      class:active={currentTabId === tab.id}
      on:click={() => currentTabId = tab.id}
    >
      {tab.label}
    </button>
  {/each}
</div>

<style>
  .tab {
    cursor: pointer;
  }
  .active {
    color: #0e71eb;
    border-bottom: 1px solid #0e71eb;
  }
</style>
